import React from 'react';
import { useAssetReportAPI } from '../../domain/assetReport/api/AssetReport.api';
import {
  useAppStateAssetReportListStore,
  useAppStateCurrentAssetReportStore,
  useAppStatePrevAssetReportStore,
  useAppStateMonthCompareModalDataStore,
  useAppStateOwnerFilterStore,
} from '../store/AppStateStore.zustand';
import { REPORT_OWNER_TYPE, ReportOwnerType } from '../../domain/assetReport/type/AssetReport.type';

const OWNER_FILTER_OPTIONS: { label: string; value: ReportOwnerType | undefined }[] = [
  { label: '모두', value: undefined },
  { label: '남편', value: REPORT_OWNER_TYPE.HUSBAND },
  { label: '아내', value: REPORT_OWNER_TYPE.WIFE },
];

const CommonTitle = () => {
  const { assetReportList } = useAppStateAssetReportListStore();
  const { currentAssetReport, setCurrentAssetReport } = useAppStateCurrentAssetReportStore();
  const { setPrevAssetReport } = useAppStatePrevAssetReportStore();
  const { setMonthCompareModalData } = useAppStateMonthCompareModalDataStore();
  const { ownerFilter, setOwnerFilter } = useAppStateOwnerFilterStore();

  const handleAssetReportSelect = (assetReportId: string) => {
    const index = assetReportList.findIndex((assetReport) => assetReport.id === assetReportId);
    if (index === -1) {
      setCurrentAssetReport(undefined);
      setPrevAssetReport(undefined);
      return;
    }
    setCurrentAssetReport(assetReportList[index]);
    if (assetReportList.length > index + 1) {
      setPrevAssetReport(assetReportList[index + 1]);
    } else {
      setPrevAssetReport(undefined);
    }
  };

  const handleMonthCompareClick = () => {
    if (!currentAssetReport) return;
    if (assetReportList.length < 2) return;

    setMonthCompareModalData({
      isOpen: true,
      onClose: () => setMonthCompareModalData(undefined),
      currentReport: currentAssetReport,
      assetReportList,
    });
  };

  return (
    <div className="mb-10 flex justify-between items-center">
      <div className="pr-6 break-keep">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">자산 대시보드</h2>
        <p className="text-gray-500">효율적인 자산 관리로 더 나은 미래를 설계하세요</p>
      </div>
      <div className="flex items-center gap-3 flex-wrap justify-end">
        {/* 소유자 필터 */}
        <div className="flex items-center bg-gray-100 rounded-lg p-1">
          {OWNER_FILTER_OPTIONS.map((option) => (
            <button
              key={String(option.value)}
              onClick={() => setOwnerFilter(option.value)}
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                ownerFilter === option.value
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
        {assetReportList.length > 0 && currentAssetReport && (
          <>
            <div className="relative">
              <select
                value={currentAssetReport.id}
                onChange={(e) => handleAssetReportSelect(e.target.value)}
                className="appearance-none bg-white border border-gray-200 rounded-lg py-2.5 pl-4 pr-10 text-gray-700 shadow-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-500 cursor-pointer !rounded-button whitespace-nowrap transition-all duration-200"
              >
                {assetReportList.map((assetReport) => (
                  <option value={assetReport.id}>{assetReport.yearMonth}</option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
            <button
              onClick={handleMonthCompareClick}
              className="bg-blue-600 text-white px-4 py-2.5 rounded-lg hover:bg-blue-700 transition-all duration-200 flex items-center space-x-2 !rounded-button whitespace-nowrap"
            >
              <i className="fas fa-chart-line"></i>
              <span>월별 비교</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CommonTitle;
